/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Creatorcode_Description1Inputs */

const id_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah Anda ingin mendukung egdata.app dengan menggunakan kode kreator kami saat membeli game? Pilihan ini akan diingat untuk kunjungan mendatang.`)
};

const ms_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adakah anda ingin menyokong egdata.app dengan menggunakan kod pencipta kami semasa membeli permainan? Pilihan ini akan diingati untuk lawatan akan datang.`)
};

const da_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vil du gerne støtte egdata.app ved at bruge vores creator-kode når du køber spil? Dette valg vil blive husket til fremtidige besøg.`)
};

const de_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchten Sie egdata.app unterstützen, indem Sie unseren Creator-Code beim Kauf von Spielen verwenden? Diese Wahl wird für zukünftige Besuche gespeichert.`)
};

const en_us2_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would you like to support egdata.app by using our creator code when purchasing games? This choice will be remembered for future visits.`)
};

const es_es2_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Te gustaría apoyar a egdata.app usando nuestro código de creador al comprar juegos? Esta elección se recordará para futuras visitas.`)
};

const es_mx2_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Te gustaría apoyar a egdata.app usando nuestro código de creador al comprar juegos? Esta elección se recordará para futuras visitas.`)
};

const fil_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gusto mo bang suportahan ang egdata.app sa pamamagitan ng paggamit ng aming creator code kapag bumibili ng laro? Ang pagpipiliang ito ay tatandaan para sa mga susunod na pagbisita.`)
};

const fr_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souhaitez-vous soutenir egdata.app en utilisant notre code créateur lors de vos achats de jeux ? Ce choix sera mémorisé pour vos prochaines visites.`)
};

const it_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi supportare egdata.app usando il nostro codice creatore quando acquisti giochi? Questa scelta verrà ricordata per le visite future.`)
};

const hu_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szeretnéd támogatni az egdata.app-ot a kreator kódunk használatával játékvásárlás során? Ezt a választást megjegyezzük a későbbi látogatásokhoz.`)
};

const nl_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wil je egdata.app steunen door onze creatorcode te gebruiken bij het kopen van games? Deze keuze wordt onthouden voor toekomstige bezoeken.`)
};

const no_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vil du støtte egdata.app ved å bruke skaperkoden vår når du kjøper spill? Dette valget vil bli husket for fremtidige besøk.`)
};

const pl_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czy chciałbyś wesprzeć egdata.app, używając naszego kodu twórcy przy zakupie gier? Ten wybór zostanie zapamiętany na przyszłe wizyty.`)
};

const pt_br2_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você gostaria de apoiar egdata.app usando nosso código de criador ao comprar jogos? Esta escolha será lembrada em futuras visitas.`)
};

const pt_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gostaria de apoiar o egdata.app usando o nosso código de criador ao comprar jogos? Esta escolha será lembrada para futuras visitas.`)
};

const ro_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dorești să sprijini egdata.app folosind codul nostru de creator atunci când achiziționezi jocuri? Această alegere va fi reținută pentru vizite viitoare.`)
};

const fi_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haluatko tukea egdata.appia käyttämällä luojakoodiamme ostaessasi pelejä? Tämä valinta muistetaan tulevia käyntejä varten.`)
};

const sv_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vill du stödja egdata.app genom att använda vår skaparkod när du köper spel? Detta val kommer att kommas ihåg för framtida besök.`)
};

const vi_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có muốn hỗ trợ egdata.app bằng cách sử dụng mã sáng tạo của chúng tôi khi mua game không? Lựa chọn này sẽ được ghi nhớ cho các lần truy cập sau.`)
};

const tr_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun satın alırken oluşturucu kodumuzu kullanarak egdata.app'i desteklemek ister misiniz? Bu seçim gelecek ziyaretleriniz için hatırlanacaktır.`)
};

const cs_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chcete podpořit egdata.app použitím našeho tvůrčího kódu při nákupu her? Tato volba bude zapamatována pro budoucí návštěvy.`)
};

const bg_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бихте ли искали да подкрепите egdata.app, като използвате нашия създателски код при закупуване на игри? Този избор ще бъде запомнен за бъдещи посещения.`)
};

const ru_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хотели бы вы поддержать egdata.app, используя наш код создателя при покупке игр? Этот выбор запомнится при последующих посещениях.`)
};

const uk_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Бажаєте підтримати egdata.app, використовуючи наш код творця під час покупки ігор? Цей вибір запам'ятається для майбутніх візитів.`)
};

const ar_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل ترغب في دعم egdata.app باستخدام رمز المنشئ الخاص بنا عند شراء الألعاب؟ سيتم تذكر هذا الخيار للزيارات المستقبلية.`)
};

const hi_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या आप गेम खरीदते समय हमारे क्रिएटर कोड का उपयोग करके egdata.app का समर्थन करना चाहेंगे? यह विकल्प भविष्य की विज़िट के लिए याद रखा जाएगा।`)
};

const th_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณต้องการสนับสนุน egdata.app โดยใช้โค้ดผู้สร้างของเราเมื่อซื้อเกมหรือไม่? ตัวเลือกนี้จะถูกจดจำสำหรับการเยี่ยมชมครั้งต่อไป`)
};

const ja_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム購入時にクリエイターコードを使用して egdata.app をサポートしませんか？この選択は今後の訪問のために記憶されます。`)
};

const zh_cn2_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您愿意在购买游戏时使用我们的创作者代码来支持 egdata.app 吗？此选择将在未来访问时被记住。`)
};

const zh_hant1_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您願意在購買遊戲時使用我們的創作者代碼來支援 egdata.app 嗎？此選擇將在未來造訪時被記住。`)
};

const ko_store_creatorcode_description1 = /** @type {(inputs: Store_Creatorcode_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 구매 시 당사의 크리에이터 코드를 사용하여 egdata.app을 지원하시겠습니까? 이 선택은 향후 방문 시 기억됩니다.`)
};

/**
* | output |
* | --- |
* | "Would you like to support egdata.app by using our creator code when purchasing games? This choice will be remembered for future visits." |
*
* @param {Store_Creatorcode_Description1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const store_creatorcode_description1 = /** @type {((inputs?: Store_Creatorcode_Description1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Creatorcode_Description1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_store_creatorcode_description1(inputs)
	if (locale === "ms") return ms_store_creatorcode_description1(inputs)
	if (locale === "da") return da_store_creatorcode_description1(inputs)
	if (locale === "de") return de_store_creatorcode_description1(inputs)
	if (locale === "en-US") return en_us2_store_creatorcode_description1(inputs)
	if (locale === "es-ES") return es_es2_store_creatorcode_description1(inputs)
	if (locale === "es-MX") return es_mx2_store_creatorcode_description1(inputs)
	if (locale === "fil") return fil_store_creatorcode_description1(inputs)
	if (locale === "fr") return fr_store_creatorcode_description1(inputs)
	if (locale === "it") return it_store_creatorcode_description1(inputs)
	if (locale === "hu") return hu_store_creatorcode_description1(inputs)
	if (locale === "nl") return nl_store_creatorcode_description1(inputs)
	if (locale === "no") return no_store_creatorcode_description1(inputs)
	if (locale === "pl") return pl_store_creatorcode_description1(inputs)
	if (locale === "pt-BR") return pt_br2_store_creatorcode_description1(inputs)
	if (locale === "pt") return pt_store_creatorcode_description1(inputs)
	if (locale === "ro") return ro_store_creatorcode_description1(inputs)
	if (locale === "fi") return fi_store_creatorcode_description1(inputs)
	if (locale === "sv") return sv_store_creatorcode_description1(inputs)
	if (locale === "vi") return vi_store_creatorcode_description1(inputs)
	if (locale === "tr") return tr_store_creatorcode_description1(inputs)
	if (locale === "cs") return cs_store_creatorcode_description1(inputs)
	if (locale === "bg") return bg_store_creatorcode_description1(inputs)
	if (locale === "ru") return ru_store_creatorcode_description1(inputs)
	if (locale === "uk") return uk_store_creatorcode_description1(inputs)
	if (locale === "ar") return ar_store_creatorcode_description1(inputs)
	if (locale === "hi") return hi_store_creatorcode_description1(inputs)
	if (locale === "th") return th_store_creatorcode_description1(inputs)
	if (locale === "ja") return ja_store_creatorcode_description1(inputs)
	if (locale === "zh-CN") return zh_cn2_store_creatorcode_description1(inputs)
	if (locale === "zh-Hant") return zh_hant1_store_creatorcode_description1(inputs)
	return ko_store_creatorcode_description1(inputs)
});
export { store_creatorcode_description1 as "store.creatorCode.description" }